import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFacebook = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="m28 9.312-3.081.002c-2.416 0-2.885 1.122-2.885 2.768v3.632h5.763l-.75 5.69h-5.013V36h-6.01V21.404H11v-5.69h5.025V11.52c0-4.87 3.042-7.52 7.484-7.52 2.128 0 3.957.154 4.491.224z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M30 5.5v1h-7a4.5 4.5 0 0 0-4.5 4.5v13h-1V11A5.5 5.5 0 0 1 23 5.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFacebook);

export default ForwardRef;
